<script setup lang="ts">
import { defineProps } from "vue";

export interface BlogSingleWidgetProps {
  title?: string;
  items?: Array<{ name: string; count: number; link: string }>;
}

const props = defineProps<BlogSingleWidgetProps>();
const route = useRoute();

const isLinkActive = (link: string) => {
  const url = new URL(link, "http://localhost");
  const currentPath = route.path;
  const currentQuery = route.query;
  
  if (url.pathname !== currentPath) return false;

  const linkParams = new URLSearchParams(url.search);
  
  for (const [key, value] of linkParams) {
    if (currentQuery[key] !== value) return false;
  }
  
  const currentQueryKeys = Object.keys(currentQuery);
  const linkQueryKeys = Array.from(linkParams.keys());
  
  if (currentQueryKeys.length !== linkQueryKeys.length) return false;

  return true;
};
</script>

<template>
  <aside class="single-widget">
    <h4 class="widget-title">{{ props.title }}</h4>
    <ul class="post-category-list">
      <template v-for="(item, index) in props.items" :key="`${item.name}-${index}`">
        <li v-if="item.count != 0">
          <NuxtLink :href="item.link" :class="{ 'filter-active': isLinkActive(item.link) }">
            {{ item.name }}
            <span v-if="item.count > 0">({{ item.count }})</span>
          </NuxtLink>
        </li>
      </template>
    </ul>
  </aside>
</template>
<style scoped>
h4.widget-title,
h4.widget-title::before {
  color: var(--title-color);
  /* background: var(--background-color) none repeat scroll 0 0; */
}
.filter-active {
  font-weight: bold;
  color: var(--primary-color);
}
</style>
